export const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

// HEIC/HEIF stay in the OS file-picker accept list ON PURPOSE: we don't support
// HEIC (no conversion — see `useImageUpload`), but letting the user pick one
// lets us show a clear "unsupported format" dialog instead of silently greying
// it out. `ACCEPTED_IMAGE_TYPES` above is the real post-pick allow-list.
export const ACCEPTED_IMAGE_TYPES_STRING = [
  ...ACCEPTED_IMAGE_TYPES,
  "image/heic",
  "image/heif",
  ".heic",
  ".heif",
].join(",");
